import { put, call } from 'redux-saga/effects';
import { replace } from 'react-router-redux';

import { PRE_ZIP_CODE_VALIDATION, ZIP_CODE_VALIDATION } from '../constants/api';
import { callHttp } from '../utils/api';
import { post, get } from '../utils/httpUtil';

import * as routes from '../constants/routes';

import { handleError, setZipCodeInfo, setValidationFlag } from '../actions';

import * as zipCodes from '../constants/zipCode';

export function* preZipCodeValidation({ payload: path }) {
  try {
    const {
      hasAddress,
      deepLinkInfo: { createdInUnic, blocked, allowedAttempts, attemptsLeft },
    } = yield callHttp(get, PRE_ZIP_CODE_VALIDATION(path));

    if (!(createdInUnic || !hasAddress)) {
      yield put(
        setZipCodeInfo({
          status: blocked
            ? zipCodes.BLOCKED_STATUS
            : zipCodes.ASK_FOR_ZIP_CODE_STATUS,
          attemptsAllowed: allowedAttempts,
          attemptsLeft,
          path,
        })
      );
      yield put(replace(routes.ZIP_CODE_VALIDATION));
    } else {
      yield put(setValidationFlag(false));
      yield put(replace(path));
    }
  } catch (err) {
    yield put(handleError(err));
  }
}

export function* validateZipCode({ payload: { zipCode, token } }) {
  try {
    const {
      correctZipCode,
      deepLinkInfo: { blocked, allowedAttempts, attemptsLeft },
    } = yield call(get, ZIP_CODE_VALIDATION(zipCode), token);

    if (blocked || !correctZipCode) {
      yield put(
        setZipCodeInfo({
          status: !attemptsLeft
            ? zipCodes.NO_ATTEPMTS_LEFT_STATUS
            : blocked
            ? zipCodes.BLOCKED_STATUS
            : zipCodes.INCORRECT_ZIP_CODE_STATUS,
          attemptsAllowed: allowedAttempts,
          attemptsLeft,
        })
      );
      yield put(replace(routes.ZIP_CODE_VALIDATION));
    } else if (correctZipCode) {
      yield put(setValidationFlag(false));
    }
  } catch (err) {
    yield put(handleError(err));
  }
}
